import { render, staticRenderFns } from "./SafetyAccidentNumberOfStaff.vue?vue&type=template&id=b956dbfc&scoped=true"
import script from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js"
export * from "./SafetyAccidentNumberOfStaff.vue?vue&type=script&lang=js"
import style0 from "./SafetyAccidentNumberOfStaff.vue?vue&type=style&index=0&id=b956dbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b956dbfc",
  null
  
)

export default component.exports